import React from 'react';

const PALETTE = [
  'bg-school-info-soft text-school-info',
  'bg-school-warning-soft text-school-warning',
  'bg-school-success-soft text-school-success',
  'bg-school-danger-soft text-school-danger',
  'bg-school-gold-soft text-school-ink',
];

/** Hebrew-style initials: "יונתן לוי" → "י״ל"; Latin: "John Doe" → "JD". */
function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const letters = parts.slice(0, 2).map((p) => p[0]);
  const isHebrew = /[֐-׿]/.test(letters.join(''));
  if (isHebrew && letters.length === 2) return `${letters[0]}״${letters[1]}`;
  return letters.join('').toUpperCase();
}

function colorFor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) % 997;
  return PALETTE[hash % PALETTE.length];
}

interface AvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASSES: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-lg',
};

const Avatar: React.FC<AvatarProps> = ({ name, size = 'md' }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold ${SIZE_CLASSES[size]} ${colorFor(name)}`}
    aria-hidden="true"
  >
    {initials(name)}
  </span>
);

export default Avatar;
